import type { OrderCostGroup } from "./types";

export const ORDER_COST_GROUPS: OrderCostGroup[] = [
  "estimated",
  "actual",
  "additionalRevenue",
];

export const orderTabKeys = ["1", "2", "3"];

export const orderStatusByTab: Record<string, string | undefined> = {
  1: "PENDING_APPROVAL",
  2: "SHIPPING",
  3: "FINISHED",
};

export const REQUIRED_FIELDS = [
  "customerName",
  "loadingDate",
  "returnDate",
  "transportType",
  "productName",
  "containerType",
  "weight",
  "deliveryMethod",
];

export const REQUIRED_FINISH = [
  {
    label: "Số cont",
    value: "containerNumber",
  },
  { label: "Nhà xe", value: "truckVendorName" },
  { label: "Biển số xe", value: "licensePlate" },
];
